import { PageApiError } from '@api/utils/PageApiError'

export function getIsExpiredScorePageError(error: unknown) {
    return (
        error instanceof PageApiError &&
        error.result?.some(a => a.message === 'No data')
    )
}
